"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IAPropertiesDetails = void 0;
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
/**
 * IA properties that are used by the individual applications detail requests.
 */
class IAPropertiesDetails {
}
exports.IAPropertiesDetails = IAPropertiesDetails;
_a = echain_shared_igus_fundamentals_1.AppName.EIQ, _b = echain_shared_igus_fundamentals_1.AppName.EKE, _c = echain_shared_igus_fundamentals_1.AppName.EIC, _d = echain_shared_igus_fundamentals_1.AppName.ECF;
IAPropertiesDetails[_a] = [
    'Id',
    'EchainId',
    'ArtNr',
    'ArtNrDE',
    'ArtNrUS',
    'ArtNrConnect',
    'ArtNrIntersect',
    'ArticleSpecs',
    'Artikeltyp',
    'ArtyConnect',
    'ArtyIntersect',
    'BestTyp',
    'Bezeichnung',
    'Breite',
    'DataSource',
    'FreigabeEIC',
    'Fussbreite',
    'Gewicht',
    'IABodenH',
    'IAHKB',
    'IAHKBOT',
    'IAHKDist',
    'IAHKH',
    'IAHKHeight',
    'IAHKOLB',
    'IAHKOLOB',
    'IAHKOLOH',
    'IAHKOLUB',
    'IAHKOLUH',
    'IAHKOLUH_Rounded',
    'IAHKORB',
    'IAHKOROB',
    'IAHKORUB',
    'IAHKRep',
    'IAHKULB',
    'IAHKULOB',
    'IAHKULOH',
    'IAHKULOH_Rounded',
    'IAHKULUB',
    'IAHKULUH',
    'IAHKURB',
    'IAHKUROB',
    'IAHKURUB',
    'IAKisteHO',
    'IAKisteHU',
    'IARef',
    'IAUebermass',
    'IAwmm',
    'KetteRef',
    'KetteSerieRef',
    'Kind',
    'Montiert',
];
IAPropertiesDetails[_b] = IAPropertiesDetails[echain_shared_igus_fundamentals_1.AppName.EIQ];
IAPropertiesDetails[_c] = IAPropertiesDetails[echain_shared_igus_fundamentals_1.AppName.EKE];
IAPropertiesDetails[_d] = ['EchainId'];
//# sourceMappingURL=IAPropertiesDetails.js.map